import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-media__body gfu-search-form-item__body _flexcol _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { "data-qa": "search-form-item:Skeleton" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.count, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "gfu-search-form-item gfu-media _px-3 _px-4--m _py-1"
        }, [
          _createVNode(_component_skeleton_image, {
            size: 42,
            class: "gfu-search-form-item__image"
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_skeleton_line, {
              height: 8,
              class: "gfu-search-form-item__skeleton-title"
            }),
            _createVNode(_component_skeleton_line, {
              height: 6,
              class: "gfu-search-form-item__skeleton-subtitle"
            })
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}